import React from 'react';
import './ListOfSubsystems.scss';
import HeaderPrint from "../HeaderPrint/HeaderPrint";
import TableSubsystems from "./TableSubsystems";

const ListOfSubsystems = ({data}) => {

  try {
    return (
      <>
        {data?.data?.data.map((item, index) => (
          <React.Fragment>
            <section className="print__subsystems">
              <HeaderPrint
                englishTitle={"List of subsystems"}
                persianTitle={"فهرست زیر سیستم ها"}
                color={"#FF7300"}
              />
              <div className="print__subsystems__text__box">
                <div className="print__subsystems__text iransans-b">
                  <div className="print__subsystems__name">
                    <span>کاربـر</span>
                    <span>:</span>
                    <span>{item.user}</span>
                  </div>
                  <div className="print__subsystems__date ">
                    <span>تاریخ</span>
                    <span>:</span>
                    <span>{item.date}</span>
                  </div>
                </div>
              </div>
              <div className="print__table__subsystem__box">
                <TableSubsystems tableItems={item.table}/>
              </div>
            </section>
            {index < data?.data?.data.length - 1 && (
              <div style={{pageBreakBefore: "always"}}></div>
            )}
          </React.Fragment>
        ))}
      </>
    );
  } catch (e) {
    return <>{e.toLocaleString()}</>
  }
};

export default ListOfSubsystems;